export const NEW = "NEW";
export const DRAFT = "DRAFT";
export const SUBMITTED = "SUBMITTED";
